// extracted by mini-css-extract-plugin
export default {"image":"style_image__K-cKJ","primaryImg":"style_primaryImg__LCTcr","options":"style_options__b2zMR","editorChoice":"style_editorChoice__kqA7W"};